module.exports = __webpack_public_path__ + "static/media/recruit1.1a6e3a2d.jpg";